module.exports = __webpack_public_path__ + "static/video-placeholder-48f43037a9752711959e309999bf9517.jpg";